import type { Goal, GoalId, MonthIndex, Project } from '@finsim/model';
import { createEvent, sample } from 'effector';
import { $project, commandIssued } from '../../entities/project';
import { assumptionsOpened } from '../../entities/selection';
import { newId } from '../../shared/lib/id';

/** A new goal: net worth of 100 000 (today's money) by the end of the horizon. */
export function defaultGoal(project: Project, id: GoalId, name: string): Goal {
  return {
    id,
    name,
    metric: 'netWorth',
    target: 100_000,
    by: (project.assumptions.horizonMonths - 1) as MonthIndex,
    real: true,
  };
}

/** Adds a goal (with its localised default name) and opens it in the assumptions inspector. */
export const goalAddRequested = createEvent<{ name: string }>();

sample({
  clock: goalAddRequested,
  source: $project,
  filter: (project) => project !== null,
  fn: (project, { name }) => ({
    command: {
      type: 'goal/add' as const,
      goal: defaultGoal(project as Project, newId('goal') as GoalId, name),
    },
  }),
  target: commandIssued,
});
sample({ clock: goalAddRequested, target: assumptionsOpened });
